<button type="button" (click)="getVehicleType()" id="vehicleTypeBtn" style="display:none"></button>
<button type="button" (click)="UpdateDeletePermit()" id="vehicleDeleteBtn" style="display:none"></button>
<div class="col-12" *ngIf="pageload">
  <app-busy [message]="message"></app-busy>
</div>
<div class="container-fluid card border-light shadow-sm" style="overflow-x:inherit !important">
    <div class="row">
      <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
        <h6>
          <span style="padding-right:5px"></span>
          <b>Vehicle<a class="red-asterik"> *</a></b><span style="color:red"> You can add one or more Vehicles in the Application with different Start Dates</span>
          <!-- <div classs="change-dec" *ngIf="replaceVehicle">Replacing Vehicle <span *ngIf="listvehicles.length>0">{{listvehicles[0].registration_number}}, {{listvehicles[0].vehicle_type}}</span></div> -->
        </h6>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <!-- <ngx-loading [show]="gridload"></ngx-loading> -->
          <div class="col-md-12 mb-2 pr-0"  *ngIf="(isProcess || dataCntrl.status == '2') && !isAmmendRoute">
            
            <button title="More vehicle details" [disabled]="((dataCntrl.permittype.temp_long_ind != 2 || (dataCntrl.permittype.temp_long_ind != 1 && dataCntrl.permittype.freight_passenger_ind == 1))) || this.dataCntrl.application.status_id == permitStatus13  || isCorrection || isDuplicate" class="btn-add-vehicle pull-right btn btn-primary btn-sm" style="border-radius:0px;" (click)="addApplicatioWithoutVehicle()">
              Add Application without vehicle
            </button>
            <button title="More vehicle details" [disabled]="isCorrection || (isDuplicate) || (dataCntrl.permittype.temp_long_ind == 2 && dataCntrl.permittype.freight_passenger_ind == 2 && this.dataCntrl.vehicles.length > 0 && this.dataCntrl.application.status_id == permitStatus13)" class="pull-right btn-add-vehicle btn btn-primary btn-sm mr-2" style="border-radius:0px;" (click)="viewVehicleEntry()">
              Add Application(s) with vehicle
            </button>
          </div>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th *ngIf="isViewMode == true && this.dataCntrl.application.status_id >= 51">Permit Num</th>
                <th style="min-width:150px;">Valid From Date</th>
                <th *ngIf="dataCntrl.permittype.can_specify_duration == true">No. Of Days</th>
                <th>Vehicle Type</th>
                <!-- <th>Make</th> -->
                <th>Registration No.</th>
                <!-- <th>No. of Seats</th> -->
                <th>Passengers</th>
                <th>GVM</th>
                <th>VIN</th>
                <th style="min-width:150px;">License or Roadworthy or C.O.F Expiry Date</th>
                <!-- <th style="min-width:150px;">Date From</th> -->
                <th *ngIf="isProcess">
                    <!-- <button title="Add a vehicle" class="btn-add btn btn-primary btn-sm" (click)="viewVehicleEntry()">
                      <i class="fa fa-plus" aria-hidden="true"></i>
                        </button> -->
                  </th>
                  <th *ngIf="isProcess">
                    <!-- <button title="More vehicle details" class="btn-view btn btn-primary btn-sm"  (click)="viewVehicleEntry()">
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </button> -->
                  </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of listvehicles, let i=index">
                <ng-container>
                <!-- <th scope="row">{{i+1}}</th> -->
                <td style="position:relative" *ngIf="isViewMode && this.dataCntrl.application.status_id >= 51 && item.permit_num !=''">
                  {{item.permit_num}}
                </td>
                <td style="position:relative">
                  <span *ngIf="item.editMode==false">{{item.start_date }}</span>
                  
                  <input type="text" [minDate]="currentDate" name="start-date" [placement]="'top'" container="body" ngbDatepicker #d="ngbDatepicker"  (focus)="d.toggle()"    *ngIf="item.editMode==true" class="form-control select-input"
                  [(ngModel)]="item.start_date"  #c{{i}}="ngModel" placeholder="dd/mm/yyyy" required="" style="z-index: 9999 !important;" style="background:white" readonly/>
                </td>

                  
                  <td style="width: 15%;" *ngIf="dataCntrl.permittype.can_specify_duration == true">
                    <span *ngIf="item.editMode==false">{{item.noOfDays}}</span>
                    <input type="text" *ngIf="item.editMode==true" [disabled]="isCorrection || isAmmendRoute" class="form-control select-input" [(ngModel)]="item.noOfDays"/>
                  </td>
                <td style="width: 25%;">
                  <span *ngIf="item.editMode==false">{{item.vehicle_type}}</span>
                    <select  [attr.disabled]="true" *ngIf="item.editMode==true" [disabled]="replaceVehicle || isCorrection || isAmmendRoute" class="form-control select-auto"  id="vehicle_type" [(ngModel)]="item.vehicle_type_id"  (change)="onVehicleTypeSelected(i)" title="Vehichle type">
                      <option value="-1">Select Vehicle</option>
                      <ng-container *ngIf="replaceVehicle || isCorrection || isAmmendRoute || isDuplicate">
                        <option  [ngValue]="item.vehicle_type_id"  >{{item.vehicle_type}}</option>  
                      </ng-container>
                      <ng-container *ngIf="!replaceVehicle && !isCorrection && !isAmmendRoute && !isDuplicate">
                        <option *ngFor="let type of list_vehicle_type" [ngValue]="type.vehicle_type_id"  >{{type.vehicle_type}}</option>
                      </ng-container>
                      
                    </select>
                </td>
                <!-- <td style="width: 15%;">
                  <span *ngIf="item.editMode==false">{{item.vehicle_make}} </span>
                  <select *ngIf="item.editMode==true" class="form-control select-auto"  id="vehicle_make" [(ngModel)]="item.vehicle_make_id" [ngStyle]="{'border-color': haserror && 'red'}" (change)="onVehicleMakeSelected(i)" title="Vehichle make">
                    <option value="-1">Select Vehicle Make</option>
                    <option *ngFor="let make of list_vehicle_make" [ngValue]="make.id">{{make.description}}</option>
                  </select>
                </td> -->
                <td class="v-grid-longtext" style="width: 15%;">
                  <span *ngIf="item.editMode==false">{{item.registration_number}}</span>
                  <input type="text" name="registrationNumber" [disabled]="item.withoutVehicle  || isCorrection || isAmmendRoute" *ngIf="item.editMode==true" class="form-control select-input"
                    [(ngModel)]="item.registration_number" maxlength="20" placeholder="Registration No" required="haserror" readonly="readonly" />
                </td>
                <!-- <td style="width: 10%;">
                  <span *ngIf="item.editMode==false">{{item.seating_capacity}}</span>
                  <input type="text" name="seatingCapacity" *ngIf="item.editMode==true"  class="form-control select-input" 
                    [(ngModel)]="item.seating_capacity" placeholder="Seats" (keypress)="numberOnly($event)" />
                </td> -->
                <td style="width: 10%;">
                  <span *ngIf="item.editMode==false">{{item.number_passengers}}</span>
                  <input type="text" name="Passengers" [disabled]="item.withoutVehicle || isCorrection || isAmmendRoute || isDuplicate" *ngIf="item.editMode==true" class="form-control select-input" 
                    [(ngModel)]="item.number_passengers" (keypress)="numberOnly($event)" placeholder="Passengers" required=""  />
                </td>
                <td style="width: 20%;">
                  <span *ngIf="item.editMode==false">{{item.gvn}}</span>
                  <input type="text" name="GVM" [disabled]="item.withoutVehicle || isCorrection || isAmmendRoute" *ngIf="item.editMode==true" class="form-control select-input"
                    [(ngModel)]="item.gvn" placeholder="GVM" (keypress)="numberOnly($event)"  readonly="readonly"  />
                </td>
                <td style="width: 20%;">
                  <span title="{{item.vin}}" *ngIf="item.editMode==false">{{item.vin}}</span>
                  <input type="text" name="VIN" [disabled]="item.withoutVehicle || isCorrection|| isAmmendRoute" *ngIf="item.editMode==true" class="form-control select-input"
                    [(ngModel)]="item.vin" maxlength="17" placeholder="VIN" (keypress)="omit_special_char($event)" required="" readonly="readonly" />
                </td>
                <!-- <td style="width: 10%;">
                  <span title="{{item.vin}}" *ngIf="item.editMode==false">{{item.vin}}</span>
                  <input type="text" name="VIN" *ngIf="item.editMode==true" class="form-control select-input"
                    [(ngModel)]="item.vin" placeholder="VIN" required="" />
                </td>
                <td style="width: 10%;">
                  <span title="{{item.vin}}" *ngIf="item.editMode==false">{{item.vin}}</span>
                  <input type="text" name="VIN" *ngIf="item.editMode==true" class="form-control select-input"
                    [(ngModel)]="item.vin" placeholder="VIN" required="" />
                </td> -->
                <td>
                  <span *ngIf="item.editMode==false">{{item.date_license_expiry }}</span>
                  <input type="text"  [minDate]="currentDate" [disabled]="item.withoutVehicle || isCorrection || isAmmendRoute" name="expiry-date" [placement]="'top'" ngbDatepicker #d1="ngbDatepicker" (focus)="d1.toggle()" *ngIf="item.editMode==true" class="form-control select-input"
                  [(ngModel)]="item.date_license_expiry" #c{{i}}="ngModel" placeholder="dd/mm/yyyy" required="" container="body" style="z-index: 9999 !important;" />
                </td>
                <!-- <td>
                  <span *ngIf="item.editMode==false">{{item.date_from | date:'yyyy/MM/dd'}}</span>
                  <input type="text" name="from-date" [minDate]="currentDate" ngbDatepicker #d2="ngbDatepicker" (focus)="d2.toggle()" *ngIf="item.editMode==true" class="form-control select-input"
                  [(ngModel)]="item.date_from" placeholder="YYYY/MM/DD" required="" />
                </td> -->
                <td  *ngIf="isProcess || dataCntrl.status == '2' ">
                  <button *ngIf="item.editMode==false" type="button" [disabled]="isDuplicate || isAmmendRoute"  title="Remove Vehicle"
                    class="btn btn-danger btn-sm push-right" (click)="confirmVehicleDelete(item)">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>

                      <button *ngIf="item.editMode==true && item.withoutVehicle"  type="button"  title="Save Changes" style="margin-top: -5px !important; margin-bottom: -5px !important;"
                    class="btn btn-success btn-sm btn-cs push-right" (click)="saveVehicle(item,i)"><i class="fa fa-save"
                      aria-hidden="true"></i></button>
                      <button *ngIf="item.editMode==true && !item.withoutVehicle"  type="button"  title="Save Changes" style="margin-top: -5px !important; margin-bottom: -5px !important;"
                      class="btn btn-success btn-sm btn-cs push-right" (click)="eNatisCheck(item,i)"><i class="fa fa-save"
                        aria-hidden="true"></i></button>
                </td> 
                <td *ngIf="isProcess || dataCntrl.status == '2'">
                  <button *ngIf="item.editMode==false" type="button" [disabled]="isDuplicate" title="Change Vehicle Information"
                    class="btn btn-primary btn-sm btn-cs push-right" (click)="editVehicle(item)"><i class="fa fa-pencil"
                      aria-hidden="true"></i></button>

                      <button *ngIf="item.editMode==true" type="button" [disabled]="isDuplicate"  title="Cancel" style="margin-top: -5px !important; margin-bottom: -5px !important;"
                    class="btn btn-primary btn-sm push-right" (click)="cancelVehicle(item)"><i class="fa fa-undo"
                      aria-hidden="true"></i></button>
                </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
        
        </div>       
      </div>
      



      
  </div>
  <div class="col-12" *ngIf="isProcess || dataCntrl.status == '2'">
    <div class="col-12" *ngIf="pageload2">
      <app-busy [message]="message"></app-busy>
    </div>
    <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2" [disabled]="disableBtn" (click)="backToTab()"
    title="Back" style="float: left !important;">Back</button>
    <ng-container *ngIf="isProcess || dataCntrl.status == '2'">
    <button class="btn btn-md m-clr pull-right hd-btn" [disabled]="disableBtn" (click)="cancelApplication()" title="Cancel"  style="float: right !important;">Cancel</button>
    <button title="Save & Continueto step 3" [disabled]="disableBtn || list_vehicle_type.length == 0" type="submit" id="btnSave" (click)="saveVehicles()" class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:10px;margin-bottom:5px;  ">Save & Continue</button>
    </ng-container>
    <div *ngIf="disableBtn" >
      <button
      class="btn btn-md m-clr pull-right hd-btn mr-2"
      routerLink="/permit/approval" title="Cancel"  style="float: right !important;">
      <i class="fa fa-times"></i> Back</button>
      </div>
  </div>
  <!-- <ngx-loading [show]="pageload"></ngx-loading> -->

    





  <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <!-- <h5 class="modal-title" id="exampleModalLongTitle">Document Uploaded</h5> -->
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-xl">
  
          <div class="container-fluid card border-light shadow-sm" style="overflow-x:inherit !important">
            <div class="row">
              <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
                <h6>
                  <span style="padding-right:5px"></span>
                  <b>Vehicle</b><span style="color:lightgray"><a class="red-asterik"> *</a> Please add all vehicles linked to this application</span>
                </h6>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <!-- <ngx-loading [show]="gridload"></ngx-loading> -->
                  <div class="col-12" *ngIf="pageload">
                    <app-busy [message]="message"></app-busy>
                  </div>
                  <table class="table table-sm table-striped responsive">
                    <thead>
                      <tr>
                        <!-- <th>#</th> -->
                        <th style="min-width:150px;">Start Date</th>
                        <th>Type</th>
                        <!-- <th>Make</th> -->
                        <th>Registration No.</th>
                        <!-- <th>No. of Seats</th> -->
                        <th>Passengers</th>
                        <th>GVM</th>
                        <th>VIN</th>
                        <th style="min-width:150px;">License or Roadworthy or C.O.F Expiry Date</th>
                        <!-- <th style="min-width:150px;">Date From</th> -->
                        <th *ngIf="isProcess || dataCntrl.status == '2'">
                            <button data-dismiss="modal" title="Add a vehicle" class=" btn-add btn btn-primary btn-sm" data-toggle="modal" data-target="#addEdit" (click)="createForm()">
                              <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                          </th>
                          <!-- <th *ngIf="isProcess">
                            <button title="Add a vehicle" class=" btn-add btn btn-primary btn-sm" data-toggle="modal" data-target="#exampleModalLong" [disabled]="!btnAddNew">
                              <i class="fa fa-eye" aria-hidden="true"></i>
                                </button>
                          </th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let item of listvehicles, let i=index">
                        <!-- <th scope="row">{{i+1}}</th> -->
                        <td style="position:relative">
                          <span *ngIf="item.editMode==false">{{item.start_date }}</span>
                          <input type="text'" [minDate]="currentDate" name="start-date" ngbDatepicker #d="ngbDatepicker"  (focus)="d.toggle()"    *ngIf="item.editMode==true" class="form-control select-input"
                          [(ngModel)]="item.start_date" #c{{i}}="ngModel" placeholder="dd/mm/yyyy" required="" /></td>
        
                          
        
                        <td style="width: 25%;">
                          <span *ngIf="item.editMode==false">{{item.vehicle_type}}</span>
                            <select *ngIf="item.editMode==true" class="form-control select-auto"  id="vehicle_type" [(ngModel)]="item.vehicle_type_id"  (change)="onVehicleTypeSelected(i)" title="Vehichle type">
                              <option value="-1">Select Vehicle</option>
                              <option *ngFor="let type of list_vehicle_type" [selected]="type.vehicle_type_id==item.vehicle_type_id" [ngValue]="type.vehicle_type_id"  >{{type.vehicle_type}}</option>
                            </select>
                        </td>
                        <!-- <td style="width: 15%;">
                          <span *ngIf="item.editMode==false">{{item.vehicle_make}} </span>
                          <select *ngIf="item.editMode==true" class="form-control select-auto"  id="vehicle_make" [(ngModel)]="item.vehicle_make_id" [ngStyle]="{'border-color': haserror && 'red'}" (change)="onVehicleMakeSelected(i)" title="Vehichle make">
                            <option value="-1">Select Vehicle Make</option>
                            <option *ngFor="let make of list_vehicle_make" [ngValue]="make.id">{{make.description}}</option>
                          </select>
                        </td> -->
                        <td class="v-grid-longtext" style="width: 15%;">
                          <span *ngIf="item.editMode==false">{{item.registration_number}}</span>
                          <input type="text" name="registrationNumber" *ngIf="item.editMode==true" class="form-control select-input"
                            [(ngModel)]="item.registration_number" placeholder="Registration No" required="haserror"  readonly="readonly" />
                        </td>
                        <!-- <td style="width: 10%;">
                          <span *ngIf="item.editMode==false">{{item.seating_capacity}}</span>
                          <input type="text" name="seatingCapacity" *ngIf="item.editMode==true"  class="form-control select-input" 
                            [(ngModel)]="item.seating_capacity" placeholder="Seats" (keypress)="numberOnly($event)" />
                        </td> -->
                        <td style="width: 10%;">
                          <span *ngIf="item.editMode==false">{{item.number_passengers}}</span>
                          <input type="text" name="Passengers" *ngIf="item.editMode==true" class="form-control select-input" 
                            [(ngModel)]="item.number_passengers" (keypress)="numberOnly($event)" placeholder="Passengers" required="" />
                        </td>
                        <td style="width: 20%;">
                          <span *ngIf="item.editMode==false">{{item.gvn}}</span>
                          <input type="text" name="GVM" *ngIf="item.editMode==true" class="form-control select-input"
                            [(ngModel)]="item.gvn" placeholder="GVM" (keypress)="numberOnly($event)" />
                        </td>
                        <td style="width: 20%;">
                          <span title="{{item.vin}}" *ngIf="item.editMode==false">{{item.vin}}</span>
                          <input type="text" name="VIN" *ngIf="item.editMode==true" class="form-control select-input"
                            [(ngModel)]="item.vin" placeholder="VIN" (keypress)="omit_special_char($event)" required="" readonly="readonly" />
                        </td>
                        <!-- <td style="width: 10%;">
                          <span title="{{item.vin}}" *ngIf="item.editMode==false">{{item.vin}}</span>
                          <input type="text" name="VIN" *ngIf="item.editMode==true" class="form-control select-input"
                            [(ngModel)]="item.vin" placeholder="VIN" required="" />
                        </td>
                        <td style="width: 10%;">
                          <span title="{{item.vin}}" *ngIf="item.editMode==false">{{item.vin}}</span>
                          <input type="text" name="VIN" *ngIf="item.editMode==true" class="form-control select-input"
                            [(ngModel)]="item.vin" placeholder="VIN" required="" />
                        </td> -->
                        <td>
                          <span *ngIf="item.editMode==false">{{item.date_license_expiry }}</span>
                          <input type="text"  [minDate]="currentDate" name="expiry-date" ngbDatepicker #d1="ngbDatepicker" (focus)="d1.toggle()" *ngIf="item.editMode==true" class="form-control select-input"
                          [(ngModel)]="item.date_license_expiry" #c{{i}}="ngModel" placeholder="dd/mm/yyyy" required="" />
                        </td>
                        <!-- <td>
                          <span *ngIf="item.editMode==false">{{item.date_from | date:'yyyy/MM/dd'}}</span>
                          <input type="text" name="from-date" [minDate]="currentDate" ngbDatepicker #d2="ngbDatepicker" (focus)="d2.toggle()" *ngIf="item.editMode==true" class="form-control select-input"
                          [(ngModel)]="item.date_from" placeholder="YYYY/MM/DD" required="" />
                        </td> -->
                        <td *ngIf="isProcess || dataCntrl.status == '2'">
                          <button *ngIf="item.editMode==false" type="button"
                            class="btn btn-danger btn-sm push-right" (click)="confirmVehicleDelete(item)"><i class="fa fa-trash"
                              aria-hidden="true"></i></button>
                              <button *ngIf="item.editMode==true" type="button" 
                            class="btn btn-success btn-sm btn-cs push-right" (click)="eNatisCheck(item,i)"><i class="fa fa-save"
                              aria-hidden="true"></i></button>
                        </td>
                        <td>     
                          <button *ngIf="item.editMode==false" data-dismiss="modal" type="button" 
                            class="btn btn-primary btn-sm btn-cs push-right" data-toggle="modal" data-target="#addEdit" (click)="passForEdit(item)"><i class="fa fa-pencil"
                              aria-hidden="true"></i></button>
                              <button *ngIf="item.editMode==true" type="button" 
                            class="btn btn-primary btn-sm push-right" (click)="cancelVehicle(item)"><i class="fa fa-undo"
                              aria-hidden="true"></i></button>
                       </td>
                          
                          
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                </div>       
              </div>
              
          </div>
  
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" data-dismiss="modal">Close</button>
          <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
        </div>
      </div>
    </div>
  </div> 





<!--Add Edit Modal -->
<div class="modal fade" id="addEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="isEditData==false">Add Vehicle</h5>
        <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="isEditData==true">Edit Vehicle</h5>
        <button type="button" class="close" data-dismiss="modal" #closebutton aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-xl">
        <!-- <div class="col-md-12" *ngIf="isVehicleLoading"
        style="position: fixed; top: 0; left: 0; width: 100%;height: 100%;    z-index:99;">
        <app-busy [message]="message"></app-busy>
      </div> -->
        <form [formGroup]="myForm">

          <!-- 1st Row -->
          <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Country Of Vehicle Registration<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" id="country_id" name="country_id"
                formControlName="country_id">
                <option value="" disabled selected>Select country</option>
                <option *ngFor="let country of ddlCountries" [ngValue]="country.id">{{country.desc}}</option>
              </select>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.country_id.required">Country of vehicle registration is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Registration Number<a class="red-asterik"> *</a>
              </label>
              <input type="text" maxlength="20" class="form-control input-sm form-control-sm"
                formControlName="registration_number" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.registration_number.required">Vehicle registration number is required</p>
            </div> -->
            </div>

            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                VIN or Chassis Number<a class="red-asterik"> *</a>
              </label>
              <input type="text" maxlength="17"  class="form-control input-sm form-control-sm" id="vin" name="vin"
                formControlName="vin" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vin.required">VIN or Chassis number is required</p>
            </div> -->
            </div>





          </div>

          <!-- 2nd Row -->
          <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Type<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" id="vehicle_make_id" name="vehicle_make_id"
                formControlName="vehicle_type_id">
                <option value="" disabled selected>Select Vehicle Type</option>
                <option *ngFor="let type of list_vehicle_type" [ngValue]="type.vehicle_type_id">{{type.vehicle_type}}
                </option>
              </select>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_make_id.required">Vehicle make is required</p>
            </div> -->
            </div>

            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Make<a class="red-asterik"> *</a>
              </label>
              <select class="form-control form-control-sm" id="vehicle_make_id" name="vehicle_make_id"
                formControlName="vehicle_make_id">
                <option value="" disabled selected>Select Vehicle Make</option>
                <ng-container *ngFor="let make of list_vehicle_make">
                  <option *ngIf="make.is_active" [ngValue]="make.id">{{make.description}}</option>
                </ng-container>
              </select>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_make_id.required">Vehicle make is required</p>
            </div> -->
            </div>


            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Series
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="vehicle_series" name="vehicle_series"
                formControlName="vehicle_series" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div> -->
            </div>


          </div>


          <!-- 3rd Row -->
          <div class="row">

            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Model Derivative
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="vehicle_model" name="vehicle_model"
                formControlName="vehicle_model" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Colour
              </label>
              <input type="text" maxlength="20" class="form-control input-sm form-control-sm" id="vehicle_colour"
                name="vehicle_colour" formControlName="vehicle_colour" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div> -->
            </div>


            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Engine Number<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="engine_number" name="engine_number"
                formControlName="engine_number" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.engine_number.required">Engine number is required</p>
            </div> -->
            </div>




          </div>



          <!-- 4th Row -->
          <div class="row">

            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Gross Vehicle(GVM)<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" (keypress)="numberOnly($event)" id="gvn"
                name="gvn" formControlName="gvn" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.gvn.required"> Gross Vehicle(GVM) is required</p>
            </div> -->
            </div>


            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                License Expiry Date<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" [minDate]="currentDate" ngbDatepicker
                #d5="ngbDatepicker" placeholder="dd/mm/yyyy" (focus)="d5.toggle()" id="date_license_expiry"
                name="date_license_expiry" formControlName="date_license_expiry"  />      
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Start Date<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" ngbDatepicker #d9="ngbDatepicker"
                placeholder="dd/mm/yyyy" (focus)="d9.toggle()" id="start_date" name="start_date"
                formControlName="start_date" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.date_license_expiry.required">Start date is required</p>
            </div> -->
            </div>

          </div>

          <!-- 5th Row -->
          <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle State
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id="vehicle_state" name="vehicle_state"
                formControlName="vehicle_state" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
              <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat"></label>
              <div class="algn">
                <label for='roadworthy_status'>Roadworthy Status<a class="red-asterik"> *</a></label>
                <select type='text' id='roadworthy_status' name="roadworthy_status" formControlName="roadworthy_status"
                  class="form-control-sm">
                  <option value="" selected disabled>Select status</option>
                  <option value="roadworthy">Roadworthy</option>
                  <option value="unroadworthy">Unroadworthy</option>
                </select>
              </div>
            </div>




            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Sitting Capacity
              </label>
              <input type="text" class="form-control input-sm form-control-sm" (keypress)="numberOnly($event)"
                id="seating_capacity" name="seating_capacity" formControlName="seating_capacity" />
              <!-- <div class="form-control-feedback text-danger text-small">
            <p *ngIf="form.controls.registered_name.errors.required">Company registered name is required</p>
            <p *ngIf="form.controls.registered_name.errors.maxlength">No more than 100 characters allowed for Company Registered Name.</p>
          </div> -->
            </div>





          </div>

          <!-- 6th Row -->
          <div class="row">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Vehicle Owner Name<a class="red-asterik"> *</a>
              </label>
              <input type="text" id='vehicle_owner' name="vehicle_owner" formControlName="vehicle_owner"
                class="form-control input-sm form-control-sm" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_owner.required">Vehicle owner name is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat"></label>
              <label class="control-label hd-cat">
                Registration Year<a class="red-asterik"> *</a>
              </label>
              <input type="text" id='registration_year' name="registration_year" formControlName="registration_year"
                class="form-control input-sm form-control-sm" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.is_leased.required">This field is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat"></label>
              <div class="algn">
                <label for='is_leased'>Is the vehicle leased?<a class="red-asterik"> *</a></label>
                <select type='text' id='is_leased' name="is_leased" formControlName="is_leased" class="form-control-sm"
                  (change)="LeaseChange()">
                  <option value="" selected disabled>Select</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.is_leased.required">This field is required</p>
            </div> -->
            </div>



          </div>
          <!-- 7th Row -->
          <div class="row" *ngIf="leased=='true'||leased==true">
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Lessor Name<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id='vehicle_lessor' name="vehicle_lessor"
                formControlName="vehicle_lessor" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.vehicle_lessor.required">Lessor name is required</p>
            </div> -->
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Lessee Name<a class="red-asterik"> *</a>
              </label>
              <!-- <input type="text"  class="form-control input-sm form-control-sm" id='vehicle_lessee' name="vehicle_lessee" formControlName="vehicle_lessee"/> -->
              <input type="text" class="form-control input-sm form-control-sm" id='vehicle_lessee' name="vehicle_lessee"
                formControlName="vehicle_lessee" />
              <div class="form-control-feedback text-danger text-small">
                <!-- <p *ngIf="myForm.ontrols.vehicle_lessee.required">Lessee name is required</p> -->
              </div>
            </div>
            <div class="col-4 sp-fld">
              <label class="control-label hd-cat">
                Expiry Date Of Lease<a class="red-asterik"> *</a>
              </label>
              <input type="text" class="form-control input-sm form-control-sm" id='date_lease_expiry'
                placeholder="dd/mm/yyyy" [placement]="'top'" [minDate]="currentDate" ngbDatepicker
                #d5="ngbDatepicker" (focus)="d5.toggle()" name="date_lease_expiry" formControlName="date_lease_expiry" />
              <!-- <div class="form-control-feedback text-danger text-small">
              <p *ngIf="myForm.controls.date_lease_expiry.required">Expiry date of lease is required</p>
            </div> -->
            </div>

          </div>
        </form>

      </div>
      <div class="modal-footer">
        <button type="button"  class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="SaveModal()" *ngIf="isEditData==false">Add Vehicle</button>
        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
      </div>
    </div>
  </div>
</div>